module.exports = __webpack_public_path__ + "static/media/Country Club Dr, South San Francisco, CA2.b4128194.jpg";